import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheckCircle, faCopy, faLink, faUser } from '@fortawesome/free-solid-svg-icons'
import { Container, Button, Spinner, InputGroup, FormControl, Alert } from 'react-bootstrap'

import PlanoTratamentoService from '../../services/planoTratamento.service'
import { printParcelasReceipt } from '../Templates/PrintableReceipt'
import { TIPOS_TEMPLATE } from '../../constants/template.constants'
import { toast } from 'react-toastify'

export default function Impressao({
  avaliacao,
  pagamentos,
  numeroPlano,
  planoId,
  procedimentosSelecionados,
  modoFinalizacao,
  linkAssinatura: linkAssinaturaProp,
  linksAssinatura: linksAssinaturaProp,
  onReconsultarLink,
}) {
  const [isPrintLoading, setIsPrintLoading] = useState(false)
  const [proteticoSelecionado, setProteticoSelecionado] = useState(false)
  const [linkAssinatura, setLinkAssinatura] = useState(linkAssinaturaProp)
  const [linksAssinatura, setLinksAssinatura] = useState(linksAssinaturaProp || null)
  const [reconsultando, setReconsultando] = useState(false)

  useEffect(() => {
    if (linkAssinaturaProp) setLinkAssinatura(linkAssinaturaProp)
  }, [linkAssinaturaProp])

  useEffect(() => {
    if (linksAssinaturaProp && linksAssinaturaProp.length > 0) setLinksAssinatura(linksAssinaturaProp)
  }, [linksAssinaturaProp])

  useEffect(() => {
    setProteticoSelecionado(procedimentosSelecionados.some((proc) => !!proc.avaliacaoProcedimentoProtetico))
  }, [procedimentosSelecionados])

  const parcelas = pagamentos.map((pag) => pag.parcelas)
  let parcelasProtese = [...parcelas]
  parcelasProtese.shift()
  const contratante = avaliacao.paciente
    ? {
        ...avaliacao.paciente,
        endereco: avaliacao.paciente.enderecos[0],
      }
    : {}
  const paciente = avaliacao.dependenteId
    ? {
        ...avaliacao.dependente,
        endereco: contratante.endereco,
      }
    : { ...contratante }

  const handleImprimirTermoConsentimento = async () => {
    setIsPrintLoading(true)
    await PlanoTratamentoService.downloadTemplateAsPDF(planoId, TIPOS_TEMPLATE.TermoDeConsentimentoDeTratamento)
    setIsPrintLoading(false)
  }

  const handleImprimirAnexo = async () => {
    setIsPrintLoading(true)
    await PlanoTratamentoService.downloadTemplateAsPDF(planoId, TIPOS_TEMPLATE.AnexoContrato)
    setIsPrintLoading(false)
  }

  const handleImprimirContrato = async () => {
    setIsPrintLoading(true)
    await PlanoTratamentoService.downloadTemplateAsPDF(planoId, TIPOS_TEMPLATE.Contrato)
    setIsPrintLoading(false)
  }

  const handleImprimirRespostasAnamnese = async () => {
    setIsPrintLoading(true)
    await PlanoTratamentoService.downloadTemplateAsPDF(planoId, TIPOS_TEMPLATE.RespostasAnamnese)
    setIsPrintLoading(false)
  }

  const handleImprimirGuia = async () => {
    setIsPrintLoading(true)
    await PlanoTratamentoService.downloadTemplateAsPDF(planoId, TIPOS_TEMPLATE.GuiaDeOrientacaoDeProtese)
    setIsPrintLoading(false)
  }

  const handleImprimirCarne = () => {
    const nomeProtese = []
    procedimentosSelecionados.map(procedimento => {
      if (procedimento.avaliacaoProcedimentoProtetico)
      {
          nomeProtese.push({'id': procedimento.avaliacaoProcedimentoProtetico.id, 'nome': procedimento.avaliacaoProcedimentoProtetico.procedimentoProtetico.nome})
      }
    });

    pagamentos.forEach((pag) => {
      printParcelasReceipt({
        numeroPlano,
        nomeContratante: contratante.nome,
        nomePaciente: paciente.nome,
        nomeProtese: pag.avaliacaoProcedimentoProteticoId ? nomeProtese.find((x) => x.id == pag.avaliacaoProcedimentoProteticoId).nome : '',
        parcelas: pag.parcelas,
        valorTotal: pag.valorTotal,
        type: pag.avaliacaoProcedimentoProteticoId ? 'protese' : 'plano',
      })
    })
  }

  const copiarLink = (url) => {
    const link = url ?? linkAssinatura
    if (!link) return
    navigator.clipboard.writeText(link).then(() => toast.success('Link copiado.')).catch(() => toast.error('Não foi possível copiar.'))
  }

  const reconsultarLink = async () => {
    if (!onReconsultarLink || !avaliacao?.id) return
    setReconsultando(true)
    try {
      const { data } = await onReconsultarLink()
      const primeiro = Array.isArray(data) && data.length > 0 ? data[0] : null
      const links = primeiro?.linksAssinatura
      const link = primeiro?.linkAssinatura
      if (links && links.length > 0) {
        setLinksAssinatura(links)
        setLinkAssinatura(links[0]?.link ?? link)
        toast.success('Links atualizados.')
      } else if (link) {
        setLinksAssinatura(null)
        setLinkAssinatura(link)
        toast.success('Link atualizado.')
      } else {
        toast.info('Nenhum link disponível para esta avaliação.')
      }
    } catch (e) {
      toast.error('Erro ao reconsultar link.')
    }
    setReconsultando(false)
  }

  if (modoFinalizacao === 'digital') {
    return (
      <Container className='text-center pb-5'>
        <div className='mb-5'>
          <FontAwesomeIcon style={{ fontSize: '11em' }} className='text-success mt-5 mb-3' icon={faCheckCircle} />
          <h2 style={fontStyle} className='text-success'>
            Link de assinatura gerado
          </h2>
        </div>
        <p className='text-muted mb-4'>
          {linksAssinatura && linksAssinatura.length > 1
            ? 'Envie cada link à pessoa correspondente para assinatura do documento.'
            : 'Envie o link abaixo ao contratante para assinatura do documento.'}
        </p>
        {linksAssinatura && linksAssinatura.length > 0 ? (
          <div className='mb-4 mx-auto' style={{ maxWidth: '600px' }}>
            {linksAssinatura.map((item, index) => (
              <div key={index} className='mb-3'>
                <label className='d-block text-left small font-weight-bold text-secondary mb-1'>
                  {item.qualificacao}:
                </label>
                <InputGroup>
                  <FormControl readOnly value={item.link || ''} className='small' />
                  <InputGroup.Append>
                    <Button
                      variant='outline-secondary'
                      onClick={() => copiarLink(item.link)}
                      title={`Copiar link - ${item.qualificacao}`}
                    >
                      <FontAwesomeIcon icon={faCopy} />
                    </Button>
                  </InputGroup.Append>
                </InputGroup>
              </div>
            ))}
          </div>
        ) : (
          linkAssinatura && (
            <div className='mb-4 mx-auto' style={{ maxWidth: '600px' }}>
              <InputGroup>
                <FormControl readOnly value={linkAssinatura} className='small' />
                <InputGroup.Append>
                  <Button variant='outline-secondary' onClick={() => copiarLink()} title='Copiar link'>
                    <FontAwesomeIcon icon={faCopy} />
                  </Button>
                </InputGroup.Append>
              </InputGroup>
            </div>
          )
        )}
        <div className='mb-3 d-flex flex-wrap justify-content-center gap-2'>
          <Button
            variant='outline-primary'
            disabled={reconsultando || !avaliacao?.id}
            onClick={reconsultarLink}
          >
            {reconsultando ? <Spinner animation='border' size='sm' /> : <FontAwesomeIcon icon={faLink} className='mr-2' />}
            Reconsultar link
          </Button>
          {avaliacao?.pacienteId && (
            <Link to={`/pacientes/${avaliacao.pacienteId}`} className='btn btn-outline-secondary'>
              <FontAwesomeIcon icon={faUser} className='mr-2' />
              Ver detalhes do paciente
            </Link>
          )}
        </div>
        <Alert variant='info' className='mt-4 mx-auto' style={{ maxWidth: '500px' }}>
          O link pode ser consultado quantas vezes precisar. Não é possível gerar um novo link; em caso de cancelamento, utilize a rotina de cancelamento de contrato.
        </Alert>
      </Container>
    )
  }

  return (
    <Container className='text-center pb-5'>
      <div className='mb-5'>
        <FontAwesomeIcon
          style={{
            fontSize: '11em',
          }}
          className='text-success mt-5 mb-3'
          icon={faCheckCircle}
        />
        <h2 style={fontStyle} className='text-success'>
          Avaliação realizada com sucesso!
        </h2>
      </div>
      <div className='align-items-center d-flex justify-content-center'>
        <Button disabled={isPrintLoading} className='mr-3' variant='primary' onClick={handleImprimirContrato}>
          Imprimir Contrato
        </Button>
        <Button disabled={isPrintLoading} className='mr-3' variant='primary' onClick={handleImprimirAnexo}>
          Imprimir Anexo
        </Button>
        <Button disabled={isPrintLoading} className='mr-3' variant='primary' onClick={handleImprimirTermoConsentimento}>
          Imprimir Termo de Consentimento
        </Button>
        <Button disabled={isPrintLoading} className='mr-3' variant='primary' onClick={handleImprimirRespostasAnamnese}>
          Imprimir Anamnese
        </Button>
        {proteticoSelecionado && (
          <Button disabled={isPrintLoading} className='mr-3' variant='primary' onClick={handleImprimirGuia}>
            Imprimir Guia de Orientação de Prótese
          </Button>
        )}
        <Button
          disabled={isPrintLoading}
          variant='primary'
          className={isPrintLoading ? 'mr-3' : ''}
          onClick={handleImprimirCarne}
        >
          Imprimir Parcelamento
        </Button>
        {isPrintLoading && <Spinner animation='border' size='sm' variant='primary' />}
      </div>
      <div className='alert alert-warning mt-5 mx-auto w-50'>
        <strong>Pop-ups</strong> bloquados no seu navegador, <strong>AdBlock</strong> habilitado para esta página, ou
        algumas <strong>extensões</strong> e <strong>add-ons</strong> instaladas podem ocasionar em problemas ao tentar
        imprimir os documentos desejados
      </div>
    </Container>
  )
}

const fontStyle = {
  letterSpacing: '2px',
  textTransform: 'uppercase',
  fontWeight: 'bold',
}
